import { ActionTypes } from "../../constants/ActionTypes";
import { INewsReducer } from "../../interfaces/News";

const INIT_STATE: INewsReducer = {
  news: [],
  newsDetails: null,
  announcementId: "",
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_NEWS_SUCCESS: {
      return {
        ...state,
        news: action.payload,
        newsLoading: false,
        newsDetails: {},
      };
    }

    case ActionTypes.GET_NEWS: {
      return {
        ...state,
        news: [],
        newsLoading: true,
        newsDetails: {},
      };
    }

    case ActionTypes.FETCH_NEWS_BY_ID_SUCCESS: {
      return {
        ...state,
        newsLoading: false,
        newsDetails: action.payload,
      };
    }

    case ActionTypes.GET_NEWS_BY_ID: {
      return {
        ...state,
        announcementId: action.payload,
      };
    }

    default:
      return state;
  }
};
